import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

// Batches filled through the API never get a Flatfile space.
export const selectorIsImportBatchApiUpload = (batch?: Batch): boolean =>
  !batch?.metadata?.[BATCH_LABELS_WS_KEYS.flatfileBatchId];
